import anonymousNames from './anonymous-names.json'
import ui from './ui.json'

export default {
  language: 'English',
  languageTag: 'en',
  ...ui,
  anonymousNames
}
